export type PrequalPrimaryFormView = {
  status: string
  coBorrower?: unknown
  coBorrowerPromptDeclinedAt?: unknown
}

export function showPrimaryPrequalForm(prescreen: PrequalPrimaryFormView): boolean {
  if (prescreen.status !== 'awaiting_coborrower') {
    return true
  }
  return !prescreen.coBorrower && Boolean(prescreen.coBorrowerPromptDeclinedAt)
}
